import { render, staticRenderFns } from "./BannersSlider.vue?vue&type=template&id=e78f6fa4&scoped=true"
import script from "./BannersSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannersSlider.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BannersSlider.vue?vue&type=style&index=0&id=e78f6fa4&prod&lang=sass"
import style1 from "./BannersSlider.vue?vue&type=style&index=1&id=e78f6fa4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78f6fa4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIcon: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/components/ui/UiIcon.vue').default,UiMarkerPoint: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/components/ui/UiMarkerPoint.vue').default,UiSectionTitle: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/components/ui/UiSectionTitle.vue').default,UiButton: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/components/ui/UiButton.vue').default})
